import Autocomplete from 'vue-simple-suggest'
import PlaceList from '../../js-api/PlaceList'
import Zenkaku from '../../../zzl-lib/Zenkaku'

export default {
	name: 'PlaceEditor',
	props: {
		value: {
			type: Object,
		}
	},
	data() {
		const registered = this.value.id !== ''
		return {
			registered,
			id: this.value.id || null,
			name: this.value.name || '',
			acName: this.value.name || '', // onSelect() 時には name に値が反映されないので補完時専用のデータを用意する
			kana: this.value.kana || '',
			city: this.value.city || '',
			address: this.value.address || '',
			autocompleted: registered,
			afterAutocompleted: this.value.name != null, // mounted 時に input イベントが発火するため
			autoCompleteStyle: {
				vueSimpleSuggest: 'bs-suggest-wrap',
				inputWrapper: 'bs-suggest-input-wrap',
				defaultInput: 'bs-suggest-input form-control',
				suggestions: 'bs-suggest-list',
				suggestItem: 'bs-suggest-item'
			}
		}
	},
	components: {
		Autocomplete
	},
	template: `
		<div class="place-editor-container bs-suggest-formgroup" :class="{ autocompleted }">
			<div class="form-group">
				<label class="control-label">名称</label>
				<div class="form-controls">
					<Autocomplete
						v-model="name"
						:list="suggestionList"
						:styles="autoCompleteStyle"
						:filter-by-query="true"
						:filter="filterSuggestion"
						value-attribute="id"
						display-attribute="name"
						@input="onInput"
						@select="onSelect"
					>
						<div slot="suggestion-item" slot-scope="{ suggestion, query }">
							<div>{{ suggestion.name }}</div>
							<div class="small text-muted">{{ suggestion.city }}{{ suggestion.address }}</div>
						</div>
					</Autocomplete>
				</div>
			</div>
			<div class="form-group">
				<label class="control-label">よみがな</label>
				<div class="form-controls">
					<input type="text" class="form-control" v-model="kana" @change="onInput">
				</div>
			</div>
			<div class="form-group">
				<label class="control-label">所在地</label>
				<div class="form-controls">
					<div class="form-subgroup">
						<input type="text" class="form-control" v-model="city" placeholder="市町村" @change="onInput">
					</div>
					<div class="form-subgroup">
						<input type="text" class="form-control" v-model="address" placeholder="町名番地" @change="onInput">
					</div>
				</div>
			</div>
		</div>
	`,
	mounted() {
	},
	methods: {
		suggestionList () {
			return PlaceList.get()
		},
		filterSuggestion (place, query) {
			const q = query.trim().toLowerCase()
			if (q === '') return true
			return place.name.toLowerCase().indexOf(q) >= 0 || place.kana.indexOf(Zenkaku.hiragana(q)) >= 0
		},
		onInput () {
			// Select イベントの発生後、一度 input イベントが発生するので、その input イベントは無視する
			if (this.afterAutocompleted) {
				this.afterAutocompleted = false
				return
			}

			this.autocompleted = false

			this.id = null
			this.notifyChange()
		},
		onSelect (place) {
			this.autocompleted = true
			this.afterAutocompleted = true

			// 内容を設定
			this.id = place.id
			this.acName = place.name
			this.kana = place.kana
			this.city = place.city
			this.address = place.address
			this.notifyChange()
		},
		notifyChange () {
			this.$emit('input', {
				id: this.id,
				name: this.autocompleted ? this.acName : this.name,
				kana: this.kana,
				city: this.city,
				address: this.address
			})
		}
	}
}
